import HttpClient from '@/utility/http-client';

export default {
    getList(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/pay_authority/?filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}`;
        return HttpClient.instance().get(url);
    },

    getDetail(id: string) {
        const url = `/api/pay_authority/${id}`;
        return HttpClient.instance().get(url);
    },

    updateDetail(id: number, dataRequest: any) {
        const url = `/api/pay_authority/${id}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    addDetail(dataRequest: any) {
        const url = `/api/pay_authority/`;
        return HttpClient.instance().put(url, dataRequest);
    },

    updateMulti(dataRequest: any) {
        const url = `/api/pay_authority/update/`;
        return HttpClient.instance().post(url, dataRequest);
    }
};
